module.exports = require('./lib/xmlnode');
